import {
  APP_NAME_KNOCKKNOCK,
  APP_NAME_THROO,
  ORDER_CANCLE_STATUS,
  ORDER_COM_COOK_STATUS,
  ORDER_COM_DEL_STATUS,
  ORDER_COM_STATUS,
  ORDER_READY_STATUS,
  ORDER_START_DEL_STATUS,
  ORDER_WAIT_STATUS,
  RIDER_ACCEPTED,
  RIDER_ALLOCATED,
  RIDER_ALLOCATION_CANCELED,
  RIDER_ALLOCATION_CHANGED,
  RIDER_ARRIVED,
  RIDER_DROP_FINISHED,
  RIDER_PICKUP_FINISHED,
  THROO_ORDER_STATE_COLOR,
} from "../recoil/type";

export const getOrderComment = (appName: string, orderStatus: number) => {
  if (appName === APP_NAME_KNOCKKNOCK) {
    if (orderStatus === ORDER_WAIT_STATUS) return "주문접수";
    else if (orderStatus === ORDER_READY_STATUS) return "조리완료";
    // else if (orderStatus === ORDER_COM_COOK_STATUS)
    //   return "픽업완료"; // 테스트
    else if (orderStatus === ORDER_COM_COOK_STATUS) return "픽업완료";
    else if (orderStatus === ORDER_START_DEL_STATUS) return "배달완료";
    else if (orderStatus === ORDER_COM_DEL_STATUS) return "배달완료";
    else if (orderStatus === ORDER_COM_STATUS) return "주문완료";
    else if (orderStatus === ORDER_CANCLE_STATUS) return "결제취소";
    return "에러";
  }
};

export const getDeliveryComment = (appName: string, deliveryStatus: number) => {
  if (appName === APP_NAME_KNOCKKNOCK) {
    if (deliveryStatus === 0) return "주문 접수 전";
    else if (deliveryStatus === 1) return "조리중";
    else if (deliveryStatus === 2) return "조리완료";
    else if (deliveryStatus === 3) return "배달중";
    else if (deliveryStatus === 4) return "배달완료";
    return "에러";
  }
};

export const getThrooOrderCurrentStatus = (
  appName: string,
  orderStatus: string
) => {
  if (appName === APP_NAME_THROO) {
    if (orderStatus === THROO_ORDER_STATE_COLOR.STANDBY) return "결제완료";
    else if (orderStatus === THROO_ORDER_STATE_COLOR.CONFIRMED)
      return "주문접수";
    else if (orderStatus === THROO_ORDER_STATE_COLOR.PREPARED)
      return "준비완료";
    else if (orderStatus === THROO_ORDER_STATE_COLOR.CONCLUDE)
      return "주문완료";
    else if (orderStatus === THROO_ORDER_STATE_COLOR.CUSTOMER_CANCELLED)
      return "주문취소";
    else if (orderStatus === THROO_ORDER_STATE_COLOR.STORE_CANCELLED)
      return "매장주문취소";
    return "에러";
  }
};

export const getThrooOrderNextStatus = (
  appName: string,
  orderStatus: string
) => {
  if (appName === APP_NAME_THROO) {
    if (orderStatus === THROO_ORDER_STATE_COLOR.STANDBY) return "주문확인";
    else if (orderStatus === THROO_ORDER_STATE_COLOR.CONFIRMED)
      return "조리완료";
    else if (orderStatus === THROO_ORDER_STATE_COLOR.PREPARED)
      return "준비완료";
    else if (orderStatus === THROO_ORDER_STATE_COLOR.CONCLUDE)
      return "전달완료";
    else if (orderStatus === THROO_ORDER_STATE_COLOR.CUSTOMER_CANCELLED)
      return "주문취소";
    else if (orderStatus === THROO_ORDER_STATE_COLOR.STORE_CANCELLED)
      return "주문취소";
    return "에러";
  }
};

export const getRiderComment = (appName: string, deliveryStatus: string) => {
  if (appName === APP_NAME_KNOCKKNOCK) {
    if (deliveryStatus === RIDER_ACCEPTED) return "배달 주문접수";
    else if (deliveryStatus === RIDER_ALLOCATED) return "라이더 배차";
    else if (deliveryStatus === RIDER_ALLOCATION_CANCELED) return "배차취소";
    else if (deliveryStatus === RIDER_ALLOCATION_CHANGED) return "배차변경";
    else if (deliveryStatus === RIDER_ARRIVED) return "픽업지 도착";
    else if (deliveryStatus === RIDER_PICKUP_FINISHED) return "픽업완료";
    else if (deliveryStatus === RIDER_DROP_FINISHED) return "배달완료";
    return "에러";
  }
  return "에러";
};
